import { UseFormReturn } from 'react-hook-form';
import { ProjectSectionType } from '../../../interfaces/project';
import { ApplicationInterface } from '../../../interfaces/application';

export const generalSettingsState = (
  formHook: UseFormReturn<ApplicationInterface>,
): ProjectSectionType => {
  const {
    formState: { errors },
    watch,
  } = formHook;

  if (
    errors.info?.name ||
    errors.info?.country ||
    errors.setup?.namespace ||
    errors.info?.website ||
    errors.info?.supportEmail
  )
    return 'alert';

  const [name, website, supportemail] = watch(['info.name', 'info.website', 'info.supportEmail']);

  if (website && name && supportemail) return 'complete';
};

export const platformState = (
  formHook: UseFormReturn<ApplicationInterface>,
): ProjectSectionType => {
  const {
    formState: { errors },
    watch,
  } = formHook;

  const [platforms, validRedirectUris] = watch(['info.platforms', 'setup.validRedirectUris']);

  if (errors.info?.platforms || errors.setup?.validRedirectUris || platforms?.length === 0)
    return 'alert';

  if (platforms && platforms.length > 0 && validRedirectUris && validRedirectUris.length > 0)
    return 'complete';
};

export const privacyAndTermsState = (
  formHook: UseFormReturn<ApplicationInterface>,
): ProjectSectionType => {
  const {
    formState: { errors },
    watch,
  } = formHook;

  if (errors.info?.privacyUrl || errors.info?.termsUrl) return 'alert';

  const [privacyUrl, termsUrl] = watch(['info.privacyUrl', 'info.termsUrl']);

  if (privacyUrl && termsUrl) return 'complete';
};

export const ratingState = (formHook: UseFormReturn<ApplicationInterface>): ProjectSectionType => {
  const {
    formState: { errors },
    watch,
  } = formHook;

  const [rating] = watch(['rating.rating']) as string[];

  if (errors.rating?.rating || !rating || (rating !== 'TBD' && rating.length < 3)) return 'alert';

  if (rating !== 'TBD' && rating.length >= 3) return 'complete';
};

export const descriptionAndReviewState = (
  formHook: UseFormReturn<ApplicationInterface>,
): ProjectSectionType => {
  const {
    formState: { errors },
    watch,
  } = formHook;

  if (
    errors.info?.shortDescription ||
    errors.info?.description ||
    errors.assets?.appLogoUrl?.contentUrl ||
    errors.info?.dataUsePurpose
  )
    return 'alert';

  const [shortDescription, description, dataUsePurpose] = watch([
    'info.shortDescription',
    'info.description',
    'info.dataUsePurpose',
  ]);

  if (shortDescription && description && dataUsePurpose) return 'complete';
};

export const dataAttributesState = (hasPermissionsForm: boolean): ProjectSectionType => {
  if (hasPermissionsForm) return 'complete';
};
